import React from 'react'
import { useTranslation } from 'react-i18next'
import { LoaderCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'

interface Props {
  open: boolean
  title: string
  description?: React.ReactNode
  confirmLabel: string
  variant?: 'destructive' | 'default'
  submitting?: boolean
  onCancel: () => void
  onConfirm: () => void
}

const ConfirmDialog: React.FC<Props> = ({ open, title, description, confirmLabel, variant = 'default', submitting = false, onCancel, onConfirm }) => {
  const { t } = useTranslation()
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next && !submitting) onCancel() }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <div className="flex items-center justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onCancel} disabled={submitting}>{t('Common_cancel')}</Button>
          <Button variant={variant} onClick={onConfirm} disabled={submitting}>
            {submitting && <LoaderCircle className="h-4 w-4 animate-spin" />}
            {confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default ConfirmDialog
